import React, { useEffect } from "react";
import AuthBannerImage from "../../assets/images/auth-banner.png";
import { Outlet, useNavigate } from "react-router-dom";
import { isAuthenticated } from "../../shared/services/auth";

export default function AuthLayout() {
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated()) {
      navigate("/dashboard");
    }
  }, [navigate]);

  return (
    <div className="auth-layout">
      <div className="container h-full p-4">
        <div className="grid h-full m-0">
          <div className="col-12 md:col-6">
            <Outlet />
          </div>
          <div className="col-12 md:col-6 flex justify-content-center">
            <img
              className="w-full border-round-2xl h-full"
              src={AuthBannerImage}
              alt="img"
              style={{ objectFit: "cover" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
